import React from 'react';
import Page from 'components/page/page';
import PageSeo from './page-seo';
import Head from 'next/head';
import Logo from 'components/logo/logo';
import { IconDefs } from 'components/icon/icon';
import PageCookieNotification from './page-cookie-notification';
import PageFooter from './page-footer';
import useMediaQuery from 'lib/use-media-query';

type PageTemplatePropsType = {
    content?: React.ReactNode;
    extraClass?: string;
    color?: string;
    goToTopHandler?: () => void;
    showGoToButton?: boolean;
};

const PageTemplate = ({
    color,
    content,
    extraClass,
    goToTopHandler,
    showGoToButton,
}: PageTemplatePropsType) => {
    const isBreakpointsmallTabletMobileDevice = useMediaQuery(900);
    return (
        <>
            <Head>
                <link
                    id="deferred-styles"
                    rel="preload"
                    href="/night-in/fonts/Circular20/fonts-night-in.css?v=2"
                    as="style"
                />
            </Head>
            <PageSeo />
            <Page
                theme={Page.Theme.NONE}
                contentCenter={true}
                header={<Logo isWhite={true} isOld={false} width="10vw" color={color} />}
                content={content}
                cookieNotification={<PageCookieNotification />}
                extraClass={extraClass}
                footer={
                    isBreakpointsmallTabletMobileDevice ? null : (
                        <PageFooter
                            color={color}
                            goToTopHandler={goToTopHandler}
                            showGoToButton={showGoToButton}
                        />
                    )
                }
            />
            {<IconDefs />}
        </>
    );
};

export default PageTemplate;
